/* Collection labels describe vehicles; product quantities come from Shopify. */
(() => {
  'use strict';
  const plain = s => String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  const compact = s => plain(s).toLowerCase().replace(/[^a-z0-9]/g, '');
  const words = s => plain(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const wordRoots=['Tri Glide','Road Glide','Street Glide','Road King','Electra Glide','Ultra Limited','Freewheeler','Street Bob','Low Rider','Fat Bob','Heritage Classic','Fat Boy','Breakout','Super Glide','Sport Glide','Wide Glide','Sportster','Nightster','Pan America','Light Bee','Varg'];
  function label(value, title = '') {
    let s = plain(value).trim().replace(/^(?:Honda|Yamaha|Kawasaki|Suzuki|KTM|Husqvarna|Husaberg|Gas[ -]?Gas|BMW|Harley[ -]Davidson|Can[ -]Am)\s+/i, '');
    s=s.replace(/^(\d{3,4})\s*ADV\b/i,'$1 Adventure');
    s=s.replace(/^(?:Stark\s+)?VARG\b/i,'Varg').replace(/^(?:SUR[- ]?RON\s+)?LIGHT\s+BEE\b/i,'Light Bee');
    const explicitAfrica = [...new Set((title.match(/CRF\s*(?:1000|1100)\s*L/ig) || []).map(compact))];
    if (/^africa\s*twin$/i.test(s) && explicitAfrica.length === 1) return explicitAfrica[0].toUpperCase();
    if (/CRF\s*(?:1000|1100)\s*L/i.test(s)) {
      s = s.replace(/africa\s*twin/ig, '').replace(/CRF\s*(1000|1100)\s*L/ig, 'CRF$1L').trim();
      const code = s.match(/CRF(?:1000|1100)L/i)?.[0];
      if (code) s = code.toUpperCase() + ' ' + s.replace(/CRF(?:1000|1100)L/i, '').trim();
    }
    if (/^(?:tenere\s*700(?:\s*(?:xtz\s*700|t700|xtz07))?|xtz\s*700|t700)$/i.test(s)) return 'Tenere 700';
    if (/^(?:banshee\s*(?:350)?\s*(?:yfz\s*350)?|yfz\s*350)$/i.test(s)) return 'Banshee 350';
    if (/^(?:blaster\s*(?:200)?\s*(?:yfs\s*200)?|yfs\s*200)$/i.test(s)) return 'Blaster 200';
    if (/^(?:iron\s*883\s*(?:XL883N)?|XL883N)$/i.test(s)) return 'Iron 883';
    if (/^(?:iron\s*1200\s*(?:XL1200NS)?|XL1200NS)$/i.test(s)) return 'Iron 1200';
    // Equivalent names only. Cooling generation and named trim qualifiers survive.
    if (/^[RF]\s*\d{3,4}\s*GS/i.test(s)) {
      s=s.replace(/^([RF])\s*(\d{3,4})\s*GS/i,(_,a,n)=>a.toUpperCase()+n+'GS');
      s=s.replace(/\bADV\b/ig,'Adventure');
      if (/\bLC\s+Adventure\b/i.test(s))s=s.replace(/\bLC\s+Adventure\b/i,'Adventure LC');
    }
    if (/^(?:Raptor\s*700R?\s+)?YFM\s*700R$|^Raptor\s*700R$/i.test(s))return 'Raptor 700R';
    if (/^(?:Raptor\s*700R?\s+)?YFM\s*700R(?:SE)?(?:\s+(?:SE|Special Edition))?$|^Raptor\s*700R\s+(?:SE|Special Edition)$/i.test(s) && /SE|Special Edition/i.test(s))return 'Raptor 700R SE';
    // Beta lists both family-first and displacement-first spellings.
    if (/\bBeta\b/i.test(title) || /^(?:ENDURO\s+)?(?:\d{3}\s*)?(?:RR|X[- ]?TRAINER)/i.test(s)) {
    s=s.replace(/^ENDURO\s+(?=(?:RR|RX|RS|XTRAINER))/i,'');
    let beta=s.match(/^(RR(?:-S)?|RX|RS|X[- ]?TRAINER)\s*(?:(2T|4T)\s*)?(\d{3})(.*)$/i);
    if(beta)s=beta[3]+' '+beta[1].toUpperCase().replace(/X[- ]?TRAINER/,'Xtrainer')+(beta[2]?' '+beta[2].toUpperCase():'')+beta[4];
    s=s.replace(/^(\d{3})\s*(RR(?:-S)?|RX|RS|X[- ]?TRAINER)(.*)$/i,(_,n,f,t)=>n+' '+f.toUpperCase().replace(/X[- ]?TRAINER/,'Xtrainer')+t);
    if (/^\d{3} (RR(?:-S)?|RX|RS|Xtrainer)\b/i.test(s)) {
      s=s.replace(/\(2 Stroke\)|\b2[- ]Stroke\b/ig,'2T').replace(/\(4 Stroke\)|\b4[- ]Stroke\b/ig,'4T');
      s=s.replace(/\bRACING\b|\bRACE EDITION\b/ig,'Race').replace(/\bX[- ]PRO\b/ig,'X-Pro');
      const stroke=s.match(/\b[24]T\b/i)?.[0];
      if(stroke)s=s.replace(/\s*[24]T\b/ig,'').trim()+' '+stroke.toUpperCase();
    }
    }
    // GasGas family is before displacement, with F retained as a real distinction.
    s=s.replace(/^(\d{2,3})\s*(EC|EX|MC|ES|SM|EW)\s*(F)?(?=\s|$)(.*)$/i,(_,n,f,t,tail)=>f.toUpperCase()+' '+n+(t?'F':'')+(tail.trim()?' '+tail.trim():''));
    s=s.replace(/^(EC|EX|MC|ES|SM|EW)\s*(\d{2,3})\s*(F)?(?=\s|$)(.*)$/i,(_,f,n,t,tail)=>f.toUpperCase()+' '+n+(t?'F':'')+(tail.trim()?' '+tail.trim():''));
    return s.replace(/\s+/g, ' ').trim();
  }
  function titleKeys(title) {
    const clean = String(title).replace(/\bADV\b/ig,'Adventure').replace(/\s*\/\s*/g, '/');
    const tokens = words(clean).split(' ').filter(Boolean), keys = new Set();
    for (let i=0;i<tokens.length;i++) for(let n=1;n<=6 && i+n<=tokens.length;n++) {
      const part=tokens.slice(i,i+n);
      if(part.some(t=>['for','parts','accessories','and','with'].includes(t)))break;
      keys.add(part.join(''));
      keys.add(compact(label(part.join(' '),title)));
    }
    // A slash inherits the immediately preceding vehicle, not every vehicle in the title.
    for (const m of clean.matchAll(/([A-Za-z][A-Za-z-]*\s*\d{2,4}[A-Za-z-]*|\d{2,4}\s+[A-Za-z][A-Za-z-]*(?:\s+[A-Za-z][A-Za-z-]*)?)((?:\/[A-Za-z0-9-]+)+)/g)) {
      const base=compact(m[1]);
      for(const part of m[2].split('/').filter(Boolean)) {
        const suffix=compact(part);
        if (/^\d+$/.test(suffix)) keys.add(base.replace(/\d{2,4}/,suffix));
        else if (/\d/.test(suffix)) {
          keys.add(suffix);
          const prefix=base.match(/^([a-z]+)\d/);
          if(prefix&&/^\d/.test(suffix))keys.add(prefix[1]+suffix);
        }
        else {
          keys.add(base+suffix);
          if (/^[a-z]+\d+[a-z]+$/.test(base)) keys.add(base.replace(/(\d+)[a-z]+$/,'$1')+suffix);
        }
      }
    }
    // Shared displacement, e.g. 700 SM/ES, rather than a literal SMES suffix.
    for(const m of clean.matchAll(/\b(\d{2,4})\s+([A-Za-z]+(?:\/[A-Za-z]+)+)/g))for(const f of m[2].split('/')) {
      keys.add(compact(label(m[1]+' '+f,title)));keys.add(compact(f+m[1]));
    }
    // Named families whose variants have no displacement.
    for(const m of clean.matchAll(/\b(Light Bee|Varg)\s+([A-Za-z0-9]+(?:\/[A-Za-z0-9]+)+)/ig))for(const trim of m[2].split('/'))keys.add(compact(m[1]+trim));
    // A shared family also applies to space/comma/ampersand separated
    // displacements. Do not require a slash and do not interpret ranges as lists.
    for (const m of clean.matchAll(/\b(\d{2,4}(?:(?:\s*[,/&+]\s*|\s+(?:and\s+)?)(?:\d{2,4}))+)[ ]+([A-Za-z][A-Za-z-]*(?:[ ]+[A-Za-z][A-Za-z-]*){0,2})/g)) {
      const nums = m[1].match(/\d{2,4}/g).filter(n => +n < 1900);
      const family = m[2].split(/\s+/).filter((v,i,a) => !a.slice(0,i+1).some(x => /^(?:parts|accessories|for|and|with)$/i.test(x)));
      for (const n of nums) for (let k=1;k<=family.length;k++) keys.add(compact(label(n+' '+family.slice(0,k).join(' '), title)));
    }
    // Shared letter prefix: CRF250R 450R 250X 450X (also commas and slashes).
    for (const m of clean.matchAll(/\b([A-Za-z][A-Za-z-]*)[ ]*(\d{2,4}[A-Za-z]*)(?=((?:[ ,/&+]+\d{2,4}[A-Za-z]+)+))/g)) {
      for (const tail of m[3].match(/\d{2,4}[A-Za-z]+/g) || []) keys.add(compact(m[1]+tail));
    }
    // Shared lists on both axes: 950 990 SM/Duke/ADV.
    for(const m of clean.matchAll(/\b(\d{2,4}(?:(?:\s*[,/&+]\s*|\s+)(?:\d{2,4}))+)[ ]+([A-Za-z][A-Za-z-]*(?:\/[A-Za-z][A-Za-z-]*)+)/g)) {
      for(const n of m[1].match(/\d{2,4}/g)) for(const f of m[2].split('/')) {
        keys.add(compact(label(n+' '+f,title)));
        if (/^SM$/i.test(f) && /\bKTM\b/i.test(title)) keys.add(compact(n+' Supermoto'));
      }
    }
    // Displacement-first shared family: KTM 950/990 Adventure.
    for(const m of clean.matchAll(/\b(\d{2,4}(?:\/\d{2,4})+)\s+([A-Za-z][A-Za-z-]*)/g)) {
      m[1].split('/').forEach(n=>keys.add(compact(n+m[2])));
    }
    return keys;
  }
  // A family includes its real children. A child never includes its siblings.
  function parts(value) {
    const codes=String(value).match(/\b(?:DR-?Z|CRF|YZ|KX|RM|TRX|YFM)\s*\d{2,4}[A-Z]*\b/ig)||[];
    return codes.length>1?[...new Set(codes)]:[value];
  }
  function contains(parent,child,title='') {
    const a=compact(label(parent,title)),b=compact(label(child,title));
    if(a===b)return true;
    if(!/\d/.test(a)) {
      const aa=words(label(parent,title)),bb=words(label(child,title));
      return aa.length>=4 && (' '+bb+' ').includes(' '+aa+' ');
    }
    if(/^[a-z]+\d{2,4}$/.test(a))return b.startsWith(a)&&/^[a-z]/.test(b.slice(a.length));
    // The generic family includes its named Super/LC8 variants, preserving
    // their separate labels and exact child selections.
    const family = a.match(/^(\d{2,4})(adventure|duke)$/);
    if (family && new RegExp('^'+family[1]+'(?:super|lc8)'+family[2]+'(?:[a-z]|$)').test(b)) return true;
    const supermoto = a.match(/^(950|990)supermoto$/);
    if (supermoto && new RegExp('^'+supermoto[1]+'sm[rt]?$').test(b)) return true;
    const beta=a.match(/^(\d{3})rr$/);
    if(beta)return b.startsWith(a)&&/^(?:2t|4t|race|xpro|s)/.test(b.slice(a.length));
    const rawA=label(parent,title).toLowerCase(),rawB=label(child,title).toLowerCase();
    return rawB.startsWith(rawA+' ');
  }
  window.NICECNCFacetPolicy={compact,label,titleKeys,parts,contains};
})();

/* NICECNC dynamic collection fitment filters.
 * Source of truth: the products that are actually inside the current Collection.
 * No vehicle/Collection handle whitelist and no static fitment snapshot.
 */
(() => {
  'use strict';

  const PARAM = {
    make: 'filter.p.m.custom.vehicle_make',
    model: 'filter.p.m.custom.vehicle_model',
    submodel: 'filter.p.m.custom.vehicle_submodel',
    year: 'filter.p.m.custom.by_year',
    partType: 'filter.p.m.custom.part_type'
  };
  const LOCAL = '_nc_fitment';
  const EXPLICIT_SUBS = '_nc_s';
  const INTERNAL = new Set([LOCAL, EXPLICIT_SUBS, '_nc_refresh', '_nc_collection_root']);
  const EXTRA = new Set(['Merchandise', 'Payment Adjustment', 'Purchase Protection', 'Gift Cards']);
  const FITMENT_PARAMS = new Set([PARAM.make, PARAM.model, PARAM.submodel, PARAM.year]);
  const MAKE_PRIORITY = [
    'KTM', 'Husqvarna', 'GasGas', 'Yamaha', 'Honda', 'Harley-Davidson',
    'Can-Am', 'Polaris', 'Kawasaki', 'Suzuki', 'BMW', 'Beta'
  ];
  const MAKE_RANK = new Map(MAKE_PRIORITY.map((v, i) => [v, i]));
  const cache = new Map();
  const rootScopeCache = new Map();
  let initToken = 0;

  const list = value => Array.isArray(value) ? value.filter(Boolean) : value ? [value] : [];
  const uniq = values => [...new Set(values.filter(Boolean))];
  const plain = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  const compact = value => plain(value).toLowerCase().replace(/[^a-z0-9]/g, '');
  const words = value => plain(value).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const isUniversal = value => compact(value) === 'universal';
  const isExtra = value => EXTRA.has(String(value || '').trim());
  const policy = () => window.NICECNCFacetPolicy || null;

  function context(root) {
    return {
      title: root?.dataset.nicecncCollectionTitle || window.NICECNC_COLLECTION_CONTEXT?.title || '',
      handle: root?.dataset.nicecncCollectionHandle || window.NICECNC_COLLECTION_CONTEXT?.handle || ''
    };
  }

  function groupFor(param, root) {
    return root?.querySelector?.(`[data-nicecnc-filter-param="${CSS.escape(param)}"]`) || null;
  }
  function inputsFor(param, root) {
    return Array.from(root?.querySelectorAll?.(`input[name="${CSS.escape(param)}"]`) || []);
  }
  function optionWrapper(input) {
    return input?.closest?.('.checkbox-container, .block-swatch, .visual-filter, .color-swatch') || null;
  }
  function setVisible(node, visible) {
    if (!node) return;
    node.hidden = !visible;
    if (visible) node.style.removeProperty('display');
    else node.style.setProperty('display', 'none', 'important');
  }
  function setOptionVisible(input, visible) {
    setVisible(optionWrapper(input), visible || input.checked);
  }
  function setGroupVisible(group, visible) {
    setVisible(group, visible);
  }

  function basicClean(root) {
    if (!root) return;
    const listNode = root.querySelector('.product-facet__filter-list');
    const order = [PARAM.make, PARAM.model, PARAM.submodel, PARAM.year, PARAM.partType];
    if (listNode) {
      const groups = Array.from(listNode.children).filter(el => el.classList?.contains('product-facet__filter-item'));
      const ranked = groups.map((group, nativeIndex) => {
        const param = group.dataset.nicecncFilterParam || '';
        const rank = order.indexOf(param);
        return {group, nativeIndex, rank: rank < 0 ? 100 + nativeIndex : rank};
      }).sort((a, b) => a.rank - b.rank);
      ranked.forEach(({group}) => listNode.appendChild(group));
    }

    for (const group of root.querySelectorAll('.product-facet__filter-item')) {
      const param = group.dataset.nicecncFilterParam || '';
      const label = words(group.querySelector('.collapsible-toggle, label')?.textContent || '');
      if (param === 'filter.p.m.custom.model_year' || label === 'style' || label === 'more filters' || label === 'more filter') {
        group.dataset.nicecncPermanentHidden = '1';
        setGroupVisible(group, false);
      }
    }

    for (const param of [PARAM.make, PARAM.model]) {
      for (const input of inputsFor(param, root)) if (isUniversal(input.value)) setOptionVisible(input, false);
    }
    hideZeroNativeOptions(PARAM.partType, root);
    sortMakeOptions(root);
  }

  function hideZeroNativeOptions(param, root) {
    for (const input of inputsFor(param, root)) {
      if (input.disabled && !input.checked) setOptionVisible(input, false);
    }
  }

  function sortMakeOptions(root) {
    const items = inputsFor(PARAM.make, root).map(input => ({input, wrapper: optionWrapper(input)}))
      .filter(x => x.wrapper?.parentElement);
    if (items.length < 2) return;
    const parent = items[0].wrapper.parentElement;
    if (!items.every(x => x.wrapper.parentElement === parent)) return;
    items.sort((a, b) => {
      const ar = MAKE_RANK.has(a.input.value) ? MAKE_RANK.get(a.input.value) : 999;
      const br = MAKE_RANK.has(b.input.value) ? MAKE_RANK.get(b.input.value) : 999;
      if (ar !== br) return ar - br;
      return a.input.value.localeCompare(b.input.value, undefined, {sensitivity: 'base'});
    });
    items.forEach(x => parent.appendChild(x.wrapper));
  }

  function cleanURL(input, mode = 'audit') {
    const url = new URL(input, location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('view');
    for (const key of INTERNAL) url.searchParams.delete(key);
    if (mode === 'scope') {
      for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.')) url.searchParams.delete(key);
      url.searchParams.delete('sort_by');
      url.searchParams.delete('q');
    } else if (mode === 'count') {
      for (const param of FITMENT_PARAMS) url.searchParams.delete(param);
      url.searchParams.delete('sort_by');
    } else if (mode === 'products') {
      url.searchParams.delete(PARAM.submodel);
    }
    url.searchParams.sort();
    return url;
  }

  async function request(url, timeout = 15000) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.text();
    } finally {
      clearTimeout(timer);
    }
  }

  async function auditIndex(input, mode = 'count') {
    const base = cleanURL(input, mode);
    const key = `${mode}|${base.href}`;
    const old = cache.get(key);
    if (old && Date.now() - old.time < 60000) return old.promise;
    const item = {time: Date.now(), promise: (async () => {
      const products = [];
      const seen = new Set();
      let page = 1;
      let total = null;
      do {
        const url = new URL(base);
        url.searchParams.set('view', 'nicecnc-audit');
        url.searchParams.set('page', String(page));
        const data = JSON.parse(await request(url));
        if (!Array.isArray(data.products) || !Number.isInteger(data.total) || data.page !== page) throw new Error('Invalid audit response');
        if (total !== null && data.total !== total) throw new Error('Collection changed during audit');
        total = data.total;
        for (const product of data.products) {
          if (!product?.handle || seen.has(product.handle)) continue;
          seen.add(product.handle);
          products.push(normalizeProduct(product));
        }
        page = data.next;
      } while (page);
      if (total !== products.length) throw new Error(`Incomplete audit ${products.length}/${total}`);
      return products;
    })()};
    cache.set(key, item);
    item.promise.catch(() => { if (cache.get(key) === item) cache.delete(key); });
    if (cache.size > 12) cache.delete(cache.keys().next().value);
    return item.promise;
  }

  function normalizeProduct(product) {
    const p = {...product};
    p.make = uniq(list(product.make).map(String));
    p.model = uniq(list(product.model).map(String));
    p.submodel = uniq(list(product.submodel).map(String));
    p.year = uniq(list(product.year).map(String));
    p.part_type = uniq(list(product.part_type).map(String));
    p.fitments = parseFitments(product.fitment_key);
    if (!p.fitments.length) {
      for (const make of p.make.length ? p.make : ['']) for (const model of p.model.length ? p.model : ['']) for (const submodel of p.submodel.length ? p.submodel : ['']) {
        if (make || model || submodel) p.fitments.push({make, model, submodel, year: ''});
      }
    }
    return p;
  }

  function parseFitments(value) {
    const lines = Array.isArray(value) ? value : typeof value === 'string' ? value.split(/\r?\n/) : [];
    const out = [];
    for (const raw of lines) {
      const parts = String(raw || '').split('|').map(x => x.trim());
      if (parts.length < 3) continue;
      out.push({make: parts[0] || '', model: parts[1] || '', submodel: parts[2] || '', year: parts[3] || ''});
    }
    return out;
  }

  function relations(products) {
    const makes = new Set(), models = new Set(), subs = new Set();
    const modelMakes = new Map(), subModels = new Map(), subMakes = new Map();
    const add = (map, key, value) => {
      if (!key || !value) return;
      if (!map.has(key)) map.set(key, new Set());
      map.get(key).add(value);
    };
    for (const p of products) {
      p.make.forEach(v => { if (!isUniversal(v) && !isExtra(v)) makes.add(v); });
      p.model.forEach(v => { if (!isUniversal(v) && !isExtra(v)) models.add(v); });
      p.submodel.forEach(v => { if (!isUniversal(v) && !isExtra(v)) subs.add(v); });
      for (const f of p.fitments) {
        if (f.make && !isUniversal(f.make)) makes.add(f.make);
        if (f.model && !isUniversal(f.model)) models.add(f.model);
        if (f.submodel && !isUniversal(f.submodel)) subs.add(f.submodel);
        add(modelMakes, f.model, f.make);
        add(subModels, f.submodel, f.model);
        add(subMakes, f.submodel, f.make);
      }
    }
    return {makes, models, subs, modelMakes, subModels, subMakes};
  }

  function phraseInTitle(title, value) {
    const p = policy();
    const label = p?.label ? p.label(value, title) : String(value);
    const key = compact(label);
    if (!key) return false;
    const keys = p?.titleKeys ? p.titleKeys(title) : new Set();
    if (keys.has(key)) return true;
    const t = ` ${words(title)} `;
    const v = words(label);
    return v.length >= 2 && t.includes(` ${v} `);
  }

  function titleNumbers(title) {
    return new Set((String(title).match(/\b\d{2,4}\b/g) || []).map(Number).filter(n => n >= 50 && n < 1900));
  }

  function numberInValue(value, nums) {
    if (!nums.size) return true;
    const found = (String(value).match(/\d{2,4}/g) || []).map(Number);
    return found.some(n => nums.has(n));
  }

  function family(value) {
    const s = words(value);
    if (/\badventure\b|\badv\b/.test(s)) return 'adventure';
    if (/\bsuper duke\b/.test(s)) return 'duke';
    if (/\bduke\b/.test(s)) return 'duke';
    if (/\bsupermoto\b|\bsmc\b|\bsmr\b|\bsmt\b|(?:^| )sm(?: |$)/.test(s)) return 'supermoto';
    if (/\benduro\b/.test(s)) return 'enduro';
    if (/\bexc[ -]?f\b|\bexcf\b/.test(s)) return 'excf';
    if (/\bexc\b/.test(s)) return 'exc';
    if (/\bsx[ -]?f\b|\bsxf\b/.test(s)) return 'sxf';
    if (/\bsx\b/.test(s)) return 'sx';
    if (/\bxc[ -]?f[ -]?w\b|\bxcfw\b/.test(s)) return 'xcfw';
    if (/\bxc[ -]?f\b|\bxcf\b/.test(s)) return 'xcf';
    if (/\bxc[ -]?w\b|\bxcw\b/.test(s)) return 'xcw';
    if (/\bxc\b/.test(s)) return 'xc';
    if (/\brr\b/.test(s)) return 'rr';
    if (/\bxtrainer\b/.test(s)) return 'xtrainer';
    if (/\bec\b/.test(s)) return 'ec';
    if (/\bex\b/.test(s)) return 'ex';
    if (/\bmc\b/.test(s)) return 'mc';
    if (/\bte\b/.test(s)) return 'te';
    if (/\bfe\b/.test(s)) return 'fe';
    if (/\btc\b/.test(s)) return 'tc';
    if (/\bfc\b/.test(s)) return 'fc';
    if (/\btx\b/.test(s)) return 'tx';
    if (/\bfx\b/.test(s)) return 'fx';
    return '';
  }

  function familiesInTitle(title) {
    const out = new Set();
    const checks = [
      ['adventure', /\badventure\b|\badv\b/i], ['duke', /\bduke\b/i],
      ['supermoto', /\bsupermoto\b|\bsmc\b|\bsmr\b|\bsmt\b|(?:^|[\s/])sm(?:[\s/]|$)/i],
      ['enduro', /\benduro\b/i], ['excf', /\bexc[ -]?f\b|\bexcf\b/i], ['exc', /\bexc\b(?!\s*[- ]?f)/i],
      ['sxf', /\bsx[ -]?f\b|\bsxf\b/i], ['sx', /\bsx\b(?!\s*[- ]?f)/i], ['xcfw', /\bxc[ -]?f[ -]?w\b|\bxcfw\b/i],
      ['xcf', /\bxc[ -]?f\b|\bxcf\b/i], ['xcw', /\bxc[ -]?w\b|\bxcw\b/i], ['xc', /\bxc\b(?!\s*[- ]?[fw])/i],
      ['rr', /\brr\b/i], ['xtrainer', /\bxtrainer\b/i], ['ec', /\bec\b/i], ['ex', /\bex\b/i], ['mc', /\bmc\b/i],
      ['te', /\bte\b/i], ['fe', /\bfe\b/i], ['tc', /\btc\b/i], ['fc', /\bfc\b/i], ['tx', /\btx\b/i], ['fx', /\bfx\b/i]
    ];
    for (const [name, re] of checks) if (re.test(String(title))) out.add(name);
    return out;
  }

  function familyCompatible(hints, candidate) {
    if (!hints.size) return true;
    if (!candidate) return false;
    if (hints.has(candidate)) return true;
    const parent = {excf: 'exc', sxf: 'sx', xcf: 'xc', xcfw: 'xcw'};
    if (parent[candidate] && hints.has(parent[candidate])) return true;
    return false;
  }

  function cleanDescendant(parent, child, title) {
    const p = policy();
    if (parent === child) return true;
    if (!p?.contains?.(parent, child, title)) return false;
    const a = plain(p?.label ? p.label(parent, title) : parent).trim();
    const b = plain(p?.label ? p.label(child, title) : child).trim();
    if (b.toLowerCase().startsWith(a.toLowerCase()) && b.length > a.length) {
      const suffix = b.slice(a.length);
      // Legacy concatenations such as YZ85TEAM/YZ125TEAM are not separate
      // customer-facing Submodels. Real trims use a separator ("YZ450F Team").
      if (/^[A-Za-z]{2,}$/.test(suffix)) return false;
    }
    return true;
  }

  function inferScope(products, title) {
    const rel = relations(products);
    const p = policy();
    const nums = titleNumbers(title);
    const hints = familiesInTitle(title);

    const titleMakes = [...rel.makes].filter(v => phraseInTitle(title, v));
    const scopedMakes = new Set(titleMakes.length ? titleMakes : rel.makes.size === 1 ? rel.makes : []);

    const subValues = [...rel.subs];
    let anchors = new Set(subValues.filter(v => {
      if (!phraseInTitle(title, v)) return false;
      const f = family(p?.label ? p.label(v, title) : v);
      return !hints.size || !f || familyCompatible(hints, f);
    }));
    // If the title names only a simple R/S/X trim, keep its real base beside it.
    // Do not generalize this to suffixes such as F/FX: YZ250F must never pull YZ250.
    for (const anchor of [...anchors]) {
      const a = words(p?.label ? p.label(anchor, title) : anchor);
      for (const candidate of subValues) {
        if (candidate === anchor) continue;
        const c = words(p?.label ? p.label(candidate, title) : candidate);
        if (a === `${c} r` || a === `${c} s` || a === `${c} x`) anchors.add(candidate);
      }
    }

    const relevantSubs = new Set();
    for (const value of subValues) {
      const parts = p?.parts ? p.parts(value) : [value];
      if (parts.length > 1) continue; // compound fitment labels live under Other
      const label = p?.label ? p.label(value, title) : value;
      const exactOrChild = [...anchors].some(anchor => anchor === value || cleanDescendant(anchor, value, title));
      const byNumberFamily = nums.size && (!anchors.size || nums.size > 1) && numberInValue(label, nums) && familyCompatible(hints, family(label));
      if (exactOrChild || byNumberFamily) relevantSubs.add(value);
    }

    if (!scopedMakes.size && relevantSubs.size) {
      const inferredMakes = new Set();
      for (const sub of relevantSubs) for (const make of rel.subMakes.get(sub) || []) if (!isUniversal(make)) inferredMakes.add(make);
      if (inferredMakes.size === 1) inferredMakes.forEach(v => scopedMakes.add(v));
    }

    let candidateModels = new Set();
    for (const sub of relevantSubs) for (const model of rel.subModels.get(sub) || []) if (!isUniversal(model)) candidateModels.add(model);

    if (!candidateModels.size) {
      const explicitModels = [...rel.models].filter(v => phraseInTitle(title, v));
      candidateModels = new Set(explicitModels);
    }

    if (!candidateModels.size && scopedMakes.size) {
      for (const model of rel.models) {
        const owners = rel.modelMakes.get(model) || new Set();
        if (!owners.size || [...owners].some(make => scopedMakes.has(make))) candidateModels.add(model);
      }
    }

    // If the title is specific but dirty cross-fitment values leak many models in,
    // keep only models actually represented by a relevant Submodel path.
    if (relevantSubs.size) {
      const fromSubs = new Set();
      for (const sub of relevantSubs) for (const model of rel.subModels.get(sub) || []) if (!isUniversal(model)) fromSubs.add(model);
      if (fromSubs.size) candidateModels = fromSubs;
    }

    // Prefer the most specific Model phrase named by the Collection title.
    // Example: "1290 Super Adventure" must not expose the generic Adventure layer.
    const explicitModelLabels = [...candidateModels].filter(v => {
      const vWords = words(v);
      return vWords && (` ${words(title)} `).includes(` ${vWords} `);
    });
    if (explicitModelLabels.length && nums.size <= 1) {
      const keep = explicitModelLabels.filter(v => !explicitModelLabels.some(other => {
        if (other === v) return false;
        const a = words(v), b = words(other);
        return b.length > a.length && (` ${b} `).includes(` ${a} `);
      }));
      if (keep.length) candidateModels = new Set(keep);
    }

    return {rel, scopedMakes, candidateModels, relevantSubs, anchors, nums, hints};
  }

  function modelValuesForMakes(scope, makes) {
    if (!makes?.size) return new Set(scope.candidateModels.size ? scope.candidateModels : scope.rel.models);
    const out = new Set();
    for (const model of scope.rel.models) {
      const owners = scope.rel.modelMakes.get(model) || new Set();
      if (!owners.size || [...owners].some(make => makes.has(make))) out.add(model);
    }
    if (scope.candidateModels.size) return new Set([...out].filter(v => scope.candidateModels.has(v)));
    return out;
  }

  function subValuesForModels(scope, models, title) {
    const p = policy();
    let pool = [...scope.rel.subs];
    if (models?.size) pool = pool.filter(sub => {
      const owners = scope.rel.subModels.get(sub) || new Set();
      return !owners.size || [...owners].some(model => models.has(model));
    });
    if (scope.relevantSubs.size) {
      const filtered = pool.filter(v => scope.relevantSubs.has(v));
      if (filtered.length) pool = filtered;
    }
    return new Set(pool.filter(v => !isUniversal(v) && !isExtra(v) && (p?.parts ? p.parts(v).length === 1 : true)));
  }

  function currentSelected(param, root) {
    return new Set(inputsFor(param, root).filter(i => i.checked && !isUniversal(i.value) && !isExtra(i.value)).map(i => i.value));
  }

  function rebuildList(group, param, values, checkedValues, countType) {
    const content = group?.querySelector('.collapsible__content');
    if (!content) return;
    const current = new Map(inputsFor(param, group).map(i => [i.value, i]));
    const ordered = uniq(values);
    content.replaceChildren();
    ordered.forEach((value, index) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'checkbox-container';
      const input = document.createElement('input');
      input.type = 'checkbox'; input.className = 'checkbox'; input.name = param; input.value = value;
      input.id = `nc-${countType}-${index}-${Math.random().toString(36).slice(2, 7)}`;
      input.checked = checkedValues.has(value) || current.get(value)?.checked || false;
      if (input.checked) input.setAttribute('checked', 'checked');
      const label = document.createElement('label'); label.htmlFor = input.id;
      label.append(document.createTextNode(`${value} (`));
      const count = document.createElement('span');
      count.dataset[countType === 'model' ? 'nicecncModelCount' : 'nicecncSubmodelCount'] = '';
      count.textContent = '…';
      label.append(count, document.createTextNode(')'));
      wrapper.append(input, label); content.append(wrapper);
    });
  }

  function ensureModelOptions(root, values) {
    const group = groupFor(PARAM.model, root);
    if (!group) return;
    const current = new Set(new URL(location.href).searchParams.getAll(PARAM.model));
    const existing = new Set(inputsFor(PARAM.model, root).map(i => i.value));
    if (values.some(v => !existing.has(v)) || existing.size > values.length + 8) rebuildList(group, PARAM.model, values, current, 'model');
  }

  function ensureSubmodelOptions(root, values) {
    const group = groupFor(PARAM.submodel, root);
    if (!group) return;
    const current = new Set(new URL(location.href).searchParams.getAll(PARAM.submodel));
    const existing = new Set(inputsFor(PARAM.submodel, root).map(i => i.value));
    const missing = values.some(v => !existing.has(v));
    if (group.dataset.nicecncMissingFacet === '1' || inputsFor(PARAM.submodel, root).length >= 100 || missing) {
      rebuildList(group, PARAM.submodel, values, current, 'submodel');
      group.removeAttribute('data-nicecnc-missing-facet');
      group.dataset.nicecncFilterOperator = 'OR';
    }
  }

  function sortAndGroupSubmodels(root, mainValues, title) {
    const group = groupFor(PARAM.submodel, root);
    const content = group?.querySelector('.collapsible__content');
    if (!content) return;
    content.querySelector(':scope > .nicecnc-other-submodel')?.remove();
    const main = new Set(mainValues);
    const rows = inputsFor(PARAM.submodel, root).map(input => ({input, row: optionWrapper(input)})).filter(x => x.row?.parentElement === content);
    const universal = rows.find(x => isUniversal(x.input.value));
    rows.filter(x => isExtra(x.input.value)).forEach(x => setVisible(x.row, false));
    const concrete = rows.filter(x => !isUniversal(x.input.value) && !isExtra(x.input.value));
    const top = concrete.filter(x => main.has(x.input.value));
    const other = concrete.filter(x => !main.has(x.input.value));
    const named = value => phraseInTitle(title, value) ? 0 : 1;
    top.sort((a, b) => named(a.input.value) - named(b.input.value) || a.input.value.localeCompare(b.input.value, undefined, {numeric: true, sensitivity: 'base'}));
    top.forEach(x => {
      setVisible(x.row, true); content.appendChild(x.row);
      const primary = phraseInTitle(title, x.input.value);
      x.row.classList.toggle('nicecnc-primary-submodel', primary);
      const label = x.input.labels?.[0] || x.row.querySelector('label');
      if (label) label.style.fontWeight = primary ? '600' : '';
    });
    if (universal) { setVisible(universal.row, true); content.appendChild(universal.row); }
    if (other.length) {
      const shell = document.createElement('div'); shell.className = 'nicecnc-other-submodel'; shell.style.setProperty('margin-top', '4px');
      const button = document.createElement('button'); button.type = 'button'; button.className = 'nicecnc-other-toggle'; button.dataset.nicecncOtherToggle = '1'; button.setAttribute('aria-expanded', 'false');
      button.style.cssText = 'display:flex;align-items:center;justify-content:space-between;width:100%;padding:7px 0;border:0;background:transparent;color:inherit;font:inherit;text-align:left;cursor:pointer;';
      button.innerHTML = '<span>Other</span><span aria-hidden="true" style="font-size:12px;line-height:1;margin-left:10px">▸</span>';
      const children = document.createElement('div'); children.className = 'nicecnc-other-submodel-children'; children.style.cssText = 'padding-left:20px;margin-top:2px;'; children.hidden = true;
      other.sort((a, b) => a.input.value.localeCompare(b.input.value, undefined, {numeric: true, sensitivity: 'base'}));
      other.forEach(x => { setVisible(x.row, true); x.input.dataset.nicecncOtherMember = '1'; children.appendChild(x.row); });
      shell.append(button, children); content.appendChild(shell);
      if (other.some(x => x.input.checked)) {
        button.setAttribute('aria-expanded', 'true'); button.lastElementChild.textContent = '▾'; children.hidden = false;
      }
    }
  }

  function productHasAny(product, field, values) {
    if (!values?.size) return true;
    return list(product[field]).some(v => values.has(v));
  }

  function productMatchesModel(product, value) {
    return product.model.includes(value) || product.model.some(isUniversal) || product.submodel.some(isUniversal);
  }

  function isSubDescendant(parent, child, title) {
    if (parent === child) return true;

    // Do not let theme code hide dirty metafields by treating two differently
    // stored labels for the same vehicle as interchangeable. Those values must
    // be normalized in product data. Only genuine parent -> child relationships
    // are allowed here.
    if (compact(parent) === compact(child)) return false;
    const harleyCode = value => String(value || '').toUpperCase().match(/\b(?:FL|FX|XL|RH|XG|RA)[A-Z0-9]{1,12}\b/g)?.at(-1) || '';
    const aCode = harleyCode(parent), bCode = harleyCode(child);
    if (aCode && aCode === bCode) return false;

    const p = policy();
    return !!p?.contains?.(parent, child, title);
  }

  function productMatchesSub(product, selected, title) {
    if (!selected?.size) return true;
    if (product.submodel.some(isUniversal)) return true;
    return [...selected].some(wanted => product.submodel.some(actual => isSubDescendant(wanted, actual, title)));
  }

  function baseFiltered(products, root, title, ignore = '') {
    const makes = ignore === PARAM.make ? new Set() : currentSelected(PARAM.make, root);
    const models = ignore === PARAM.model ? new Set() : currentSelected(PARAM.model, root);
    const subs = ignore === PARAM.submodel ? new Set() : currentSelected(PARAM.submodel, root);
    return products.filter(p => {
      if (makes.size && !productHasAny(p, 'make', makes) && !p.make.some(isUniversal)) return false;
      if (models.size && ![...models].some(v => productMatchesModel(p, v))) return false;
      if (subs.size && !productMatchesSub(p, subs, title)) return false;
      return true;
    });
  }

  function writeCount(input, value, kind) {
    const label = input.labels?.[0] || optionWrapper(input)?.querySelector('label');
    if (!label) return;
    let node = label.querySelector(kind === 'model' ? '[data-nicecnc-model-count]' : '[data-nicecnc-submodel-count]');
    if (!node) {
      const text = label.textContent || input.value;
      label.replaceChildren(document.createTextNode(`${text.replace(/\s*\(\d+\)\s*$/, '').trim()} (`));
      node = document.createElement('span');
      node.dataset[kind === 'model' ? 'nicecncModelCount' : 'nicecncSubmodelCount'] = '';
      label.append(node, document.createTextNode(')'));
    }
    node.textContent = String(value);
    input.disabled = value === 0 && !input.checked;
  }

  function updateCounts(root, products, title) {
    const modelBase = baseFiltered(products, root, title, PARAM.model);
    for (const input of inputsFor(PARAM.model, root)) {
      if (isUniversal(input.value)) continue;
      writeCount(input, modelBase.filter(p => productMatchesModel(p, input.value)).length, 'model');
    }
    const subBase = baseFiltered(products, root, title, PARAM.submodel);
    for (const input of inputsFor(PARAM.submodel, root)) {
      if (isExtra(input.value)) continue;
      const count = isUniversal(input.value)
        ? subBase.filter(p => p.submodel.some(isUniversal)).length
        : subBase.filter(p => productMatchesSub(p, new Set([input.value]), title)).length;
      writeCount(input, count, 'submodel');
    }
  }

  function updateYearOptions(root, products, title) {
    const base = baseFiltered(products, root, title);
    for (const input of inputsFor(PARAM.year, root)) {
      const wanted = String(input.value);
      const count = base.filter(product => {
        const years = product.year.map(String);
        return years.includes(wanted) || years.includes('All Year') || years.includes('All Years');
      }).length;
      input.disabled = count === 0 && !input.checked;
      setOptionVisible(input, count > 0 || input.checked);
      const label = input.labels?.[0] || optionWrapper(input)?.querySelector('label');
      if (label) {
        const text = label.textContent || '';
        if (/\(\d+\)/.test(text)) label.textContent = text.replace(/\(\d+\)([\s\u200e\u200f]*)$/, `(${count})$1`);
      }
    }
  }

  function showHierarchy(root, scope, countProducts) {
    const {title} = context(root);
    const selectedMakes = currentSelected(PARAM.make, root);
    const selectedModels = currentSelected(PARAM.model, root);
    const selectedSubs = currentSelected(PARAM.submodel, root);

    const makeValues = [...scope.rel.makes].filter(v => !isUniversal(v));
    const effectiveMakes = selectedMakes.size ? selectedMakes : scope.scopedMakes;
    let modelValues = [...modelValuesForMakes(scope, effectiveMakes)].filter(v => !isUniversal(v) && !isExtra(v));
    if (scope.candidateModels.size) modelValues = modelValues.filter(v => scope.candidateModels.has(v));
    ensureModelOptions(root, modelValues);

    const effectiveModels = selectedModels.size ? selectedModels : modelValues.length === 1 ? new Set(modelValues) : new Set();
    const allSubs = [...scope.rel.subs].filter(v => !isExtra(v));
    if (!allSubs.includes('Universal') && countProducts.some(p => p.submodel.some(isUniversal))) allSubs.push('Universal');
    ensureSubmodelOptions(root, allSubs);
    const mainSubs = [...subValuesForModels(scope, effectiveModels, title)];

    const makeGroup = groupFor(PARAM.make, root);
    const modelGroup = groupFor(PARAM.model, root);
    const subGroup = groupFor(PARAM.submodel, root);
    const yearGroup = groupFor(PARAM.year, root);

    const showMake = selectedMakes.size > 0 || (scope.scopedMakes.size !== 1 && makeValues.length > 1);
    const showModel = (showMake ? selectedMakes.size > 0 : true) && modelValues.length > 1;
    const modelPathReady = !showModel || selectedModels.size > 0;
    const singleCollectionBase = mainSubs.length === 1 && phraseInTitle(title, mainSubs[0]) && !selectedModels.size;
    const meaningfulSubs = mainSubs.length > 0 && !singleCollectionBase;
    const showSub = modelPathReady && meaningfulSubs;
    const showYear = modelPathReady && (!showSub || selectedSubs.size > 0);

    setGroupVisible(makeGroup, showMake);
    setGroupVisible(modelGroup, showModel);
    setGroupVisible(subGroup, showSub);
    setGroupVisible(yearGroup, showYear);

    for (const input of inputsFor(PARAM.make, root)) setOptionVisible(input, !isUniversal(input.value) && (!scope.scopedMakes.size || scope.scopedMakes.has(input.value) || selectedMakes.has(input.value)));
    for (const input of inputsFor(PARAM.model, root)) setOptionVisible(input, modelValues.includes(input.value));
    sortAndGroupSubmodels(root, new Set(mainSubs), title);
    hideZeroNativeOptions(PARAM.year, root);
    hideZeroNativeOptions(PARAM.partType, root);
    sortMakeOptions(root);
    updateCounts(root, countProducts, title);
    updateYearOptions(root, countProducts, title);
    openFirstVisiblePrimary(root);
  }

  function openFirstVisiblePrimary(root) {
    if (root.dataset.nicecncInitialOpen === '1') return;
    for (const param of [PARAM.make, PARAM.model, PARAM.submodel, PARAM.year, PARAM.partType]) {
      const group = groupFor(param, root);
      if (!group || group.hidden || group.style.display === 'none') continue;
      const button = group.querySelector('button[is="toggle-button"]');
      const content = group.querySelector('collapsible-content');
      if (button && content) {
        button.setAttribute('aria-expanded', 'true'); content.setAttribute('open', ''); content.style.overflow = 'visible';
      }
      break;
    }
    root.dataset.nicecncInitialOpen = '1';
  }

  function isAllProducts(ctx) {
    return ctx.handle === 'all' || /^all(?:\s+products?)?$/i.test(String(ctx.title || '').trim());
  }

  async function apply(root) {
    if (!root?.isConnected) return;
    basicClean(root);
    const ctx = context(root);
    if (isAllProducts(ctx)) {
      // The all-products Collection must stay on Shopify's native fast path.
      // Never build the 3k+ product audit merely to paginate or sort.
      return;
    }
    const token = ++initToken;
    try {
      const scopeURL = cleanURL(location.href, 'scope');
      const scopeKey = scopeURL.href;
      let scopePromise = rootScopeCache.get(scopeKey);
      if (!scopePromise) {
        scopePromise = auditIndex(scopeURL, 'scope').then(products => ({products, scope: inferScope(products, ctx.title)}));
        rootScopeCache.set(scopeKey, scopePromise);
        if (rootScopeCache.size > 8) rootScopeCache.delete(rootScopeCache.keys().next().value);
      }
      const countURL = cleanURL(location.href, 'count');
      const countPromise = countURL.href === scopeURL.href ? scopePromise.then(data => data.products) : auditIndex(countURL, 'count');
      const [{scope}, countProducts] = await Promise.all([scopePromise, countPromise]);
      if (!root.isConnected || token !== initToken) return;
      showHierarchy(root, scope, countProducts);
    } catch (error) {
      console.warn('[NICECNC fitment] dynamic scope unavailable; native filters kept.', error);
    }
  }

  function explicitSubs(url) {
    try {
      const value = JSON.parse(url.searchParams.get(EXPLICIT_SUBS));
      if (Array.isArray(value)) return value.filter(v => typeof v === 'string' && v && !isUniversal(v) && !isExtra(v));
    } catch (_) {}
    return url.searchParams.getAll(PARAM.submodel).filter(v => !isUniversal(v) && !isExtra(v));
  }

  function serializeFitmentURL(root) {
    const form = root?.querySelector('#facet-filters-form');
    if (!form) return null;
    const url = new URL(location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('filter.') || key === 'page' || key === 'section_id' || INTERNAL.has(key)) url.searchParams.delete(key);
    }
    for (const [key, value] of new FormData(form)) url.searchParams.append(key, value);
    const concrete = url.searchParams.getAll(PARAM.submodel).filter(v => !isUniversal(v) && !isExtra(v));
    if (concrete.length) {
      url.searchParams.set(LOCAL, '1');
      url.searchParams.set(EXPLICIT_SUBS, JSON.stringify(uniq(concrete)));
    } else {
      url.searchParams.delete(LOCAL);
      url.searchParams.delete(EXPLICIT_SUBS);
    }
    url.searchParams.delete('page');
    return url;
  }

  window.nicecncFitmentUrl = serializeFitmentURL;

  function needsLocalRender(urlLike) {
    const url = new URL(urlLike || location.href, location.href);
    return url.pathname.includes('/collections/') && url.searchParams.get(LOCAL) === '1' && explicitSubs(url).length > 0;
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function sourceSectionURL(input, sectionId, page) {
    const url = cleanURL(input, 'products');
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', String(page));
    return url;
  }

  function nativeFilterSectionURL(input, sectionId) {
    const url = new URL(input, location.href);
    for (const key of INTERNAL) url.searchParams.delete(key);
    url.searchParams.delete('page');
    url.searchParams.set('section_id', sectionId);
    return url;
  }

  async function renderLocal(input, facet) {
    const url = new URL(input, location.href);
    const sectionId = facet.getAttribute('section-id');
    const selected = new Set(explicitSubs(url));
    if (!sectionId || !selected.size) return await request(url);

    const productBase = cleanURL(url, 'products');
    const [products, filterHTML, sourceFirstHTML] = await Promise.all([
      auditIndex(productBase, 'products'),
      request(nativeFilterSectionURL(url, sectionId)),
      request(sourceSectionURL(url, sectionId, 1))
    ]);
    const ctx = context(facet.querySelector('facet-filters'));
    const matched = products.map((p, rank) => ({p, rank})).filter(({p}) => productMatchesSub(p, selected, ctx.title));
    const filterDoc = parseHTML(filterHTML);
    const sourceDoc = parseHTML(sourceFirstHTML);
    const sourceMain = sourceDoc.querySelector('#facet-main');
    const outputMain = filterDoc.querySelector('#facet-main');
    if (!sourceMain || !outputMain) throw new Error('Missing collection main');
    const pageSize = Number(sourceMain.dataset.nicecncPageSize || outputMain.dataset.nicecncPageSize);
    if (!Number.isInteger(pageSize) || pageSize < 1) throw new Error('Invalid page size');
    const pageCount = Math.max(1, Math.ceil(matched.length / pageSize));
    const page = Math.min(pageCount, Math.max(1, Number(url.searchParams.get('page')) || 1));
    const wanted = matched.slice((page - 1) * pageSize, page * pageSize);
    const sourcePages = uniq(wanted.map(({rank}) => Math.floor(rank / pageSize) + 1));
    const docs = new Map([[1, sourceDoc]]);
    const pending = sourcePages.filter(n => n !== 1);
    await Promise.all(Array.from({length: Math.min(3, pending.length)}, async () => {
      while (pending.length) {
        const n = pending.shift();
        docs.set(n, parseHTML(await request(sourceSectionURL(url, sectionId, n))));
      }
    }));
    const cards = new Map();
    for (const doc of docs.values()) for (const card of doc.querySelectorAll('#facet-main .product-list__inner > *')) {
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      const path = new URL(link.getAttribute('href'), location.origin).pathname;
      const handle = decodeURIComponent(path.split('/products/')[1]?.split('/')[0] || '');
      if (handle) cards.set(handle, card);
    }
    const outputInner = outputMain.querySelector('.product-list__inner');
    if (outputInner) {
      outputInner.replaceChildren(...wanted.map(({p}) => {
        const card = cards.get(p.handle);
        if (!card) throw new Error(`Missing product card ${p.handle}`);
        return card.cloneNode(true);
      }));
    }
    outputMain.dataset.nicecncResultCount = String(matched.length);
    const count = outputMain.querySelector('.product-facet__meta-bar-item--count');
    if (count) count.textContent = `${matched.length} ${matched.length === 1 ? 'product' : 'products'}`;
    outputMain.querySelectorAll('page-pagination').forEach(node => node.remove());
    if (pageCount > 1) outputMain.appendChild(buildPager(url, page, pageCount));
    if (!matched.length && outputInner) {
      const empty = document.createElement('p'); empty.className = 'empty-state'; empty.textContent = 'No matching products.'; outputInner.appendChild(empty);
    }
    return filterDoc.documentElement.outerHTML;
  }

  function buildPager(url, page, pages) {
    const pager = document.createElement('page-pagination'); pager.setAttribute('ajax', ''); pager.className = 'pagination';
    const nav = document.createElement('nav'); nav.className = 'pagination__nav';
    const numbers = uniq([1, page - 1, page, page + 1, pages]).filter(n => n >= 1 && n <= pages).sort((a, b) => a - b);
    numbers.forEach((n, i) => {
      if (i && n - numbers[i - 1] > 1) nav.append(document.createTextNode(' … '));
      if (n === page) {
        const span = document.createElement('span'); span.className = 'pagination__nav-item heading heading--small'; span.textContent = String(n); span.setAttribute('aria-current', 'page'); nav.append(span);
      } else {
        const link = document.createElement('a'); link.className = 'pagination__nav-item heading heading--small'; link.textContent = String(n); link.dataset.page = String(n);
        const href = new URL(url); href.searchParams.set('page', String(n)); link.href = href.href; nav.append(link);
      }
    });
    pager.append(nav); return pager;
  }

  window.NICECNCFitment = {
    needsLocalRender,
    render: renderLocal,
    apply,
    _debug: {inferScope, normalizeProduct, parseFitments, family, familiesInTitle, titleNumbers}
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-nicecnc-other-toggle="1"]');
    if (!button) return;
    event.preventDefault();
    const children = button.parentElement?.querySelector('.nicecnc-other-submodel-children');
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (button.lastElementChild) button.lastElementChild.textContent = open ? '▸' : '▾';
    if (children) children.hidden = open;
  }, true);

  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !FITMENT_PARAMS.has(input.name)) return;
    const root = input.closest('facet-filters');
    if (!root) return;
    if (input.name === PARAM.make) {
      inputsFor(PARAM.model, root).forEach(i => i.checked = false);
      inputsFor(PARAM.submodel, root).forEach(i => i.checked = false);
      inputsFor(PARAM.year, root).forEach(i => i.checked = false);
    } else if (input.name === PARAM.model) {
      inputsFor(PARAM.submodel, root).forEach(i => i.checked = false);
      inputsFor(PARAM.year, root).forEach(i => i.checked = false);
    } else if (input.name === PARAM.submodel) {
      inputsFor(PARAM.year, root).forEach(i => i.checked = false);
    }
  }, true);

  function schedule() {
    const run = () => document.querySelectorAll('facet-filters').forEach(apply);
    if ('requestIdleCallback' in window) requestIdleCallback(run, {timeout: 400});
    else setTimeout(run, 0);
  }
  schedule();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once: true});
  document.addEventListener('nicecnc:facets-rendered', schedule);
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
})();
